/* eslint-disable no-unused-vars */
// IMPORTANT above line disables eslint warning for unused imports
// We need these unused imports because of cascading css rules
// Otherwise removing unused imports causes the tenant_application.css
// in TenantApplication.js and ApplicationForm.js to be not applied.
// AND the order of these imports matter!

import React from 'react';
import { Route, IndexRoute } from 'react-router';

import TenantApp from 'TenantApp';
import LandlordApp from 'LandlordApp';
import TenantDashboard from 'components/tenant_app/TenantDashboard';
import LandlordDashboard from 'components/landlord_app/dashboard/Dashboard';
import Inspections from 'components/landlord_app/inspections/Inspections';
import InspectionTemplates from 'containers/inspections/Templates';
import LandlordTickets from 'components/landlord_app/maintenance/tickets/TicketsPage';
import BatchesPage from 'components/landlord_app/batches/BatchesPage/BatchesPage';
import BatchPage from 'components/landlord_app/batches/BatchPage/BatchPage';
import LandlordEscalation from 'components/landlord_app/maintenance/LandlordEscalation';
import LandlordAssets from 'components/landlord_app/maintenance/LandlordAssets';
import LandlordRecurringTickets from 'components/landlord_app/maintenance/LandlordRecurringTickets';
import LandlordTicketScheduler from 'components/landlord_app/maintenance/LandlordTicketScheduler/LandlordTicketScheduler';

import DocumentTemplates from 'components/landlord_app/document_templates/DocumentTemplates';
import { DocumentTemplateDetails } from 'components/landlord_app/document_templates/DocumentTemplateDetails';
import LandlordVendors from 'components/landlord_app/vendors/Vendors';
import LandlordPurchaseOrder from 'components/landlord_app/purchase_orders/LandlordPurchaseOrder';
import MaintenanceProjects from 'components/landlord_app/maintenance/projects/containers';
import MaintenanceProject from 'components/landlord_app/maintenance/projects/containers/MaintenanceProject';
import MaintenanceVendor from 'components/landlord_app/maintenance/vendors/components';
import Reporting from 'components/landlord_app/insights/Reporting';
import Rules from 'components/landlord_app/insights/Rules/index';
import ReportGenerator from 'components/landlord_app/insights/ReportGenerator';
import MaintenanceInsightsDashboard from 'components/landlord_app/insights/maintenance/MaintenanceInsightsDashboard';
import InsightDashboards from 'components/landlord_app/insights/insightDashboards/InsightDashboards';
import LandlordProspects from 'components/landlord_app/leads/LandlordProspects';
import LeadManaging from 'components/landlord_app/leads/LeadManaging/LeadManaging';
import LandlordUsers from 'components/landlord_app/users/LandlordUsers';
import LandlordTenants from 'components/landlord_app/tenants/LandlordTenants';
import RentRoll from 'components/landlord_app/rent_roll/RentRoll';
import LandlordPayments from 'components/landlord_app/payments/Payments';
import LandlordProperties from 'components/landlord_app/properties/LandlordProperties';
import LandlordFees from 'components/landlord_app/payments/LandlordFees';
import LandlordAmenities from 'components/landlord_app/community/LandlordAmenities/LandlordAmenities';
import LandlordSurveys from 'components/landlord_app/community/LandlordSurveys';
import EventCalendar from 'components/landlord_app/calendar/EventCalendar';
import EventCalendarKiosk from 'components/landlord_app/self_service_kiosk/CalendarKiosk';
import ParcelsKiosk from 'components/landlord_app/self_service_kiosk/ParcelsKiosk';
import MaintenanceTicketsKiosk from 'components/landlord_app/self_service_kiosk/MaintenanceTicketsKiosk';
import LandlordPromotions from 'components/landlord_app/promotions/LandlordPromotions';
import LandlordParcels from 'components/landlord_app/parcels/LandlordParcels';
import LandlordVisitors from 'components/landlord_app/community/LandlordVisitors';
import LandlordNotices from 'components/landlord_app/notices/LandlordNotices';
import AddProperty from 'components/landlord_app/properties/AddProperty';
import PropertyDetails from 'components/landlord_app/properties/PropertyDetails';
import LandlordShowings from 'components/landlord_app/showings/LandlordShowings';
import LandlordApplications from 'components/landlord_app/applications/LandlordApplications';
import LandlordPolicies from 'components/landlord_app/policies/LandlordPolicies';
import ReviewApplicants from 'components/landlord_app/applications/ReviewApplicants';
import LeaseCreator from 'components/landlord_app/applications/LeaseCreator';
import LeaseInPersonOverwriteCreator from 'components/landlord_app/applications/LeaseInPersonOverwriteCreator';
import ManualLeaseCreator from 'components/landlord_app/rent_roll/ManualLeaseCreator';
import LeaseCreatorForEdit from 'components/landlord_app/applications/LeaseCreatorForEdit';
import LeaseCreatorUIWizard from 'components/landlord_app/applications/LeaseCreatorUIWizard';
import RenewalCreator from 'components/landlord_app/rent_roll/components/RenewalCreator';
import MoveOutCreator from 'components/landlord_app/rent_roll/components/MoveOutCreator';
import APIDashboardDocuments from 'components/landlord_app/api_dashboard/components/DocumentsTable';
import APISettings from 'components/landlord_app/api_dashboard/components/Settings';
import APIAddAsset from 'components/landlord_app/api_dashboard/components/AddAsset';
import MaintenanceWorkerTickets from 'components/maintenance_app/MaintenanceTickets';
import MaintenanceWorkerUsers from 'components/landlord_app/users/LandlordUsers';
import TenantProfile from 'components/tenant_app/TenantProfile';
import Building from 'components/tenant_app/Building';
import Community from 'components/tenant_app/Community';
import Chat from 'components/chat/Chat';
import TenantApplication from 'components/tenant_application/TenantApplication';
import TenantLandlordReferenceVerification from 'components/tenant_app/TenantLandlordReferenceVerification';
import TenantPersonalReferenceVerification from 'components/tenant_app/TenantPersonalReferenceVerification';
import TenantMaintenanceVerification from 'components/tenant_app/TenantMaintenanceVerification';
import TenantSurvey from 'components/tenant_app/TenantSurvey';
import BookShowing from 'components/tenant_app/BookShowing';
import TenantReferral from 'components/tenant_app/TenantReferral';
import LeadCapture from 'components/tenant_app/LeadCapture';
import TenantPermitEntry from 'components/tenant_app/TenantPermitEntry';
import ApplicationRegistration from 'navigation/ApplicationRegistration';
import { UserOnboardingCentered, UserOnboardingWithBackground } from 'navigation/userOnboarding';
import InternalDocumentPortal from 'components/byesign/internalDocumentPortal';
import DocumentPortal from 'components/byesign/documentPortal';
import DocumentPortalInPerson from 'components/byesign/documentPortalInPerson';
import RenewalLeaseWizard from 'components/tenant_app/components/renewals/renewalLeaseWizard';
import { LoginCentered, LoginWithBackground } from 'navigation/login';
import {
  PasswordResetCentered,
  PasswordResetWithBackground,
  ChangePasswordCentered,
  ChangePasswordWithBackground,
} from 'navigation/passwordReset';
import ResendConfirmation from 'navigation/ResendConfirmation';
import ChangePasswordReset from 'navigation/ChangePasswordReset';
import CompanyDetails from 'navigation/CompanyProfile';
import Billing from 'navigation/Billing';
import UserPreferences from 'navigation/UserPreferences';
import Integrations from 'navigation/Integrations';
import LandlordReferrals from 'components/landlord_app/leads/referrals/LandlordReferrals';

import ApplicationManagementRoutes from 'app_routes/application_management/ApplicationManagementRoutes';

import Logs from 'containers/logs/Logs';

import { loginPage, passwordResetPage, updatePasswordPage } from './AppRoutesHelper';
import ApplicationTemplatesBuilderRoutes from './application_management/ApplicationTemplatesBuilderRoutes';
import IncentiveManagementRoutes from 'app_routes/incentive_management/IncentiveManagementRoutes';

const LandlordAppRoutes = (authenticateLandlord) => {
  return (
    <React.Fragment>
      <IndexRoute component={loginPage} />
      <Route path="dashboard" component={LandlordDashboard} onEnter={authenticateLandlord} />
      <Route path="messaging" component={Chat} onEnter={authenticateLandlord} />
      <Route
        path="maintenance/tickets"
        component={LandlordTickets}
        onEnter={authenticateLandlord}
      />
      <Route
        path="maintenance/tickets/:ticketID"
        component={LandlordTickets}
        onEnter={authenticateLandlord}
      />
      <Route path="assets" component={LandlordAssets} onEnter={authenticateLandlord} />
      <Route
        path="recurring_tickets"
        component={LandlordRecurringTickets}
        onEnter={authenticateLandlord}
      />
      <Route
        path="ticket_scheduler"
        component={LandlordTicketScheduler}
        onEnter={authenticateLandlord}
      />
      <Route path="escalation" component={LandlordEscalation} onEnter={authenticateLandlord} />
      <Route
        path="purchase_orders"
        component={LandlordPurchaseOrder}
        onEnter={authenticateLandlord}
      />
      <Route
        path="purchase_orders/:purchaseOrderId"
        component={LandlordPurchaseOrder}
        onEnter={authenticateLandlord}
      />
      <Route
        path="maintenance/projects"
        component={MaintenanceProjects}
        onEnter={authenticateLandlord}
      />
      <Route
        path="maintenance/projects/:projectID"
        component={MaintenanceProject}
        onEnter={authenticateLandlord}
      />
      <Route path="batches" component={BatchesPage} onEnter={authenticateLandlord} />
      <Route path="batches/:batchId" component={BatchPage} onEnter={authenticateLandlord} />
      <Route path="vendors" component={LandlordVendors} onEnter={authenticateLandlord} />
      <Route path="prospects" component={LandlordProspects} onEnter={authenticateLandlord} />
      <Route path="users" component={LandlordUsers} onEnter={authenticateLandlord} />
      <Route path="tenants" component={LandlordTenants} onEnter={authenticateLandlord} />
      <Route path="rent_roll" component={RentRoll} onEnter={authenticateLandlord} />
      <Route path="rent_roll/:leaseId" component={RentRoll} onEnter={authenticateLandlord} />
      <Route path="properties" component={LandlordProperties} onEnter={authenticateLandlord} />
      <Route path="fees" component={LandlordFees} onEnter={authenticateLandlord} />
      <Route path="charges" component={LandlordPayments} onEnter={authenticateLandlord} />
      <Route path="amenities" component={LandlordAmenities} onEnter={authenticateLandlord} />
      <Route path="surveys" component={LandlordSurveys} onEnter={authenticateLandlord} />
      <Route path="events" component={EventCalendar} onEnter={authenticateLandlord} />
      <Route path="promotions" component={LandlordPromotions} onEnter={authenticateLandlord} />
      <Route path="parcels" component={LandlordParcels} onEnter={authenticateLandlord} />
      <Route path="visitors" component={LandlordVisitors} onEnter={authenticateLandlord} />
      <Route path="notices" component={LandlordNotices} onEnter={authenticateLandlord} />
      <Route path="notices/:noticeId" component={LandlordNotices} onEnter={authenticateLandlord} />
      <Route path="add_property" component={AddProperty} onEnter={authenticateLandlord} />
      <Route path="property_details" component={PropertyDetails} onEnter={authenticateLandlord} />
      <Route path="showings" component={LandlordShowings} onEnter={authenticateLandlord} />
      <Route path="referrals" component={LandlordReferrals} onEnter={authenticateLandlord} />

      {ApplicationManagementRoutes(authenticateLandlord)}
      {ApplicationTemplatesBuilderRoutes(authenticateLandlord)}
      {IncentiveManagementRoutes(authenticateLandlord)}

      <Route path="inspections" component={Inspections} onEnter={authenticateLandlord} />
      <Route
        path="inspection_templates"
        component={InspectionTemplates}
        onEnter={authenticateLandlord}
      />
      <Route
        path="internal_document_portal"
        component={InternalDocumentPortal}
        onEnter={authenticateLandlord}
      />
      <Route path="review_applicants" component={ReviewApplicants} onEnter={authenticateLandlord} />
      <Route path="new_lease" component={LeaseCreator} onEnter={authenticateLandlord} />
      <Route path="lease_creator" component={LeaseCreatorUIWizard} onEnter={authenticateLandlord} />
      <Route
        path="overwrite_in_person_lease"
        component={LeaseInPersonOverwriteCreator}
        onEnter={authenticateLandlord}
      />
      <Route path="renewal_creator" component={RenewalCreator} onEnter={authenticateLandlord} />
      <Route path="move_out_creator" component={MoveOutCreator} onEnter={authenticateLandlord} />
      <Route
        path="manual_lease_creator"
        component={ManualLeaseCreator}
        onEnter={authenticateLandlord}
      />
      <Route path="edit_lease" component={LeaseCreatorForEdit} onEnter={authenticateLandlord} />
      <Route path="reporting" component={Reporting} onEnter={authenticateLandlord} />
      <Route path="rules" component={Rules} onEnter={authenticateLandlord} />
      <Route path="generate_report" component={ReportGenerator} onEnter={authenticateLandlord} />
      <Route
        path="maintenance_insights"
        component={MaintenanceInsightsDashboard}
        onEnter={authenticateLandlord}
      />
      <Route
        path="insight_dashboards"
        component={InsightDashboards}
        onEnter={authenticateLandlord}
      />
      <Route path="lead_managing" component={LeadManaging} onEnter={authenticateLandlord} />
      <Route path="agent_password_reset" component={passwordResetPage} userType="landlord" />
      <Route
        path="agent_change_password_from_email"
        component={updatePasswordPage}
        userType="landlord"
      />
      <Route
        path="agent_change_password_reset"
        component={ChangePasswordReset}
        onEnter={authenticateLandlord}
      />
      <Route path="agent_resend_confirmation" component={ResendConfirmation} />
      <Route path="company_details" component={CompanyDetails} onEnter={authenticateLandlord} />
      <Route path="billing" component={Billing} onEnter={authenticateLandlord} />
      <Route path="automation" component={UserPreferences} onEnter={authenticateLandlord} />
      <Route path="integrations" component={Integrations} onEnter={authenticateLandlord} />
      <Route path="calendar_kiosk" component={EventCalendarKiosk} onEnter={authenticateLandlord} />
      <Route path="parcels_kiosk" component={ParcelsKiosk} onEnter={authenticateLandlord} />
      <Route
        path="maintenance_tickets_kiosk"
        component={MaintenanceTicketsKiosk}
        onEnter={authenticateLandlord}
      />
      <Route
        path="api_dashboard_documents"
        component={APIDashboardDocuments}
        onEnter={authenticateLandlord}
      />
      <Route path="api_dashboard_settings" component={APISettings} onEnter={authenticateLandlord} />
      <Route
        path="api_dashboard_add_asset"
        component={APIAddAsset}
        onEnter={authenticateLandlord}
      />
      <Route path="logs" component={Logs} onEnter={authenticateLandlord} />
      <Route
        path="document_templates"
        component={DocumentTemplates}
        onEnter={authenticateLandlord}
      />
      <Route
        path="document_templates/:id"
        component={DocumentTemplateDetails}
        onEnter={authenticateLandlord}
      />
    </React.Fragment>
  );
};

export { LandlordAppRoutes };
